var map = {
	"./1.png": 2424,
	"./POIgeneric.jpg": 2425,
	"./cmentarz.jpg": 2426,
	"./hotel.jpg": 2427,
	"./kosciol.jpg": 2428,
	"./kultura.jpg": 2429,
	"./map-icon.png": 2430,
	"./przyroda.jpg": 2431,
	"./rekreacja.jpg": 2432,
	"./schronisko.jpg": 2433,
	"./swieczki.jpg": 2419,
	"./szkola.jpg": 2434,
	"./transport.jpg": 2435,
	"./x.png": 2417,
	"./zabytek.jpg": 2436
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2423;



//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img ^\.\/.*$
// module id = 2423
// module chunks = 0